export default __webpack_public_path__ + "static/media/giveaway.f0366d6b.svg";